/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import InputForm from "../../components/inputs/InputForm";
import { Toggle, Animation, toaster, RadioGroup, Radio } from "rsuite";
import peticionBack from "../../libs/peticiones/peticionBack";
import AddresForm from "./components/form/AddresForm";
import DocumentForm from "./components/form/DocumentForm";
import DatesSwitchForm from "./components/form/DatesSwitchForm";
import { CollapseFilter } from "./components/CollapseFilter";
import { FormTesis } from "./FormTesis";
import Perspectives from "./components/form/Perspectives";
import { Region } from "../../types/compl-archivos/Region";
import { Distrito } from "../../types/compl-archivos/Distrito";

export default function FormSearch({
  values,
  touched,
  errors,
  onChange,
  handleBlur,
  showForm,
  setShowForm,
  setFieldValue,
  setFieldTouched,
  typeSearch,
  setTypeSearch,
  reset,
  typeDocument,
  amnistia = false,
  onClearResults,
}: {
  values: any;
  touched: any;
  errors: any;
  onChange: any;
  handleBlur: any;
  showForm: any;
  setShowForm: any;
  setFieldValue: any;
  setFieldTouched: any;
  typeSearch: string;
  setTypeSearch: any;
  reset: any;
  typeDocument?: string;
  amnistia?: boolean;
  onClearResults?: () => void;
}) {
  const [sistemas, setSistemas] = useState<Array<any>>([]);
  const [instancias, setInstancias] = useState<Array<any>>([]);
  const [delitos, setDelitos] = useState<any>([]);
  const [areas, setAreas] = useState<Array<any>>([]);
  const [distritos, setDistritos] = useState<Array<Distrito>>([]);
  const [regiones, setRegiones] = useState<Array<Region>>([]);
  const [tiposCarpeta, setTiposCarpeta] = useState<any[]>([]);
  const [materias, setMaterias] = useState<any[]>([]);

  const [showAddresForm, setShowAddresForm] = useState(false);
  const [showCaseForm, setShowCaseForm] = useState(false);
  const [showDatesForm, setShowDatesForm] = useState(false);
  const [showPerspectives, setShowPerspectives] = useState(false);
  const [showTesis, setShowTesis] = useState(true);
  const [tipos, setTipos] = useState<Array<any>>([]);

  useEffect(() => {
    getInstancias();
    getSistemas();
    getRegiones();
    getTypeFolder();
    getMaterias();
    getTipos();
  }, []);

  useEffect(() => {
    if (values.subject) {
      getDelitos();
    }
  }, [values.subject]);

  useEffect(() => {
    if (values.region) {
      getDistritos(values.region);
    } else {
      setDistritos([]);
      setFieldValue("distrito", "");
    }
  }, [values.region]);

  useEffect(() => {
    if (values.distrito) {
      getAreas();
    } else {
      setAreas([]);
      setFieldValue("area", "");
    }
  }, [values.distrito]);

  async function getDistritos(_reg: string) {
    const res = await peticionBack(
      {},
      `/distritos?region=${values.region}`,
      "GET",
      false,
      toaster
    );
    if (res && res.data) setDistritos(res.data);
  }

  async function getDelitos() {
    setDelitos([]);
    setFieldValue("delito", "");
    const res = await peticionBack(
      {},
      `/delitos?subject=${values.subject}`,
      "GET",
      false,
      toaster
    );
    if (res.data) {
      setDelitos(res.data);
    }
  }

  async function getTipos() {
    const res = await peticionBack({}, "/tags", "GET", false, toaster);
    if (res) setTipos([...res.data]);
  }

  async function getTypeFolder() {
    const res = await peticionBack({}, "/tiposcarpeta", "GET", false, toaster);
    if (res){ 
      if(amnistia){
        setFieldValue(
          "folderType",
          res.data.find((folder: any) => folder.name === "CARPETA DE AMNISTIA")
            ._id
        );
      }
      setTiposCarpeta([...res.data]);
    }
  }
  async function getMaterias() {
    const res = await peticionBack({}, "/materias", "GET", false, toaster);
    if (res) setMaterias([...res.data]);
  }

  async function getAreas() {
    const res = await peticionBack(
      {},
      `/areas?district=${values.distrito}`,
      "GET",
      false,
      toaster
    );
    if (res) setAreas([...res.data]);
  }

  async function getInstancias() {
    const res = await peticionBack({}, "/instancias", "GET", false, toaster);
    if (res) setInstancias([...res.data]);
  }

  async function getSistemas() {
    const res = await peticionBack({}, "/sistemas", "GET", false, toaster);
    if (res) setSistemas([...res.data]);
  }
  // async function getDistritos() {
  //   const res = await peticionBack({}, "/distritos", "GET", false, toaster);
  //   if (res) setDistritos([...res.data]);
  // }
  async function getRegiones() {
    const res = await peticionBack({}, "/regiones", "GET", false, toaster);
    if (res) {
      setRegiones([...res.data]);
      setAreas([]);
    }
  }
  function clean() {
    reset();
    setShowAddresForm(false);
    setShowCaseForm(false);
    setShowPerspectives(false);
    setShowDatesForm(false);
  }

  function adminCollapse(
    collapse: "addres" | "case" | "perspectives" | "dates" | "jurisprudence",
    value: boolean
  ) {
    switch (collapse) {
      case "addres":
        setShowAddresForm(value);
        setShowCaseForm(false);
        setShowPerspectives(false);
        setShowDatesForm(false);

        break;

      case "case":
        setShowAddresForm(false);
        setShowCaseForm(value);
        setShowPerspectives(false);
        setShowDatesForm(false);

        break;
      case "perspectives":
        setShowAddresForm(false);
        setShowCaseForm(false);
        setShowPerspectives(value);
        setShowDatesForm(false);

        break;
      case "dates":
        setShowAddresForm(false);
        setShowCaseForm(false);
        setShowPerspectives(false);
        setShowDatesForm(value);

        break;
      case "jurisprudence":
        setShowTesis(value);
        break;
      default:
        break;
    }
  }
  function onChangeDocumentType(value: string) {
    if (onClearResults) {
      onClearResults();
    }
    setFieldValue("textToSearch", "");
    setFieldTouched("textToSearch", false);
    setFieldValue("typeDocument", value);
    if (value === "acuerdos") {
      setShowForm(false);
    }
  }


  return (
    <div>
      <Row>
        <Col
          xs={12}
          md={4}
          className="d-flex flex-column align-items-center justify-content-center"
        >
          {typeDocument === undefined && !amnistia ? (
            <RadioGroup
              name={"rTipoDocumento"}
              value={values.typeDocument}
              className="d-flex flex-row justify-content-center align-items-center"
            >
              <h5>Tipo de documento: </h5>
              <div className="d-flex flex-column">
                <Radio
                  value="sentencias"
                  checked={values.typeDocument === "sentencias"}
                  onChange={(e) => onChangeDocumentType(e as string)}
                >
                  SENTENCIAS
                </Radio>
                <Radio
                  value="acuerdos"
                  checked={values.typeDocument === "acuerdos"}
                  onChange={(e) => onChangeDocumentType(e as string)}
                >
                  ACUERDOS
                </Radio>
                <Radio
                  value="tesis"
                  checked={values.typeDocument === "tesis"}
                  onChange={(e) => onChangeDocumentType(e as string)}
                >
                  JURISPRUDENCIAS
                </Radio>
              </div>
            </RadioGroup>
          ) : (
            <RadioGroup
              name={"rTipoDocumento"}
              value={amnistia ? "sentencias" : typeDocument}
              className="d-flex flex-row justify-content-center align-items-center"
            >
              <h5>Tipo de documento: </h5>
              <div className="d-flex flex-column">
                <Radio
                  value={amnistia ? "sentencias" : typeDocument}
                  checked={true}
                  disabled
                >
                  {(typeDocument === "sentencias" || amnistia) && "SENTENCIAS"}
                  {typeDocument === "acuerdos" && !amnistia && "ACUERDOS"}
                  {typeDocument === "tesis" && !amnistia && "JURISPRUDENCIAS"}
                </Radio>
              </div>
            </RadioGroup>
          )}

          <RadioGroup
            name={"rTipoDocumento"}
            value={typeSearch}
            className="d-flex flex-row justify-content-center align-items-center"
          >
            <h5>Tipo de búsqueda:</h5>
            <div className="d-flex flex-column">
              <Radio
                value="match"
                checked={typeSearch === "match"}
                onChange={(e) => setTypeSearch(e)}
              >
                FRASE EXACTA
              </Radio>
              <Radio
                value="terms"
                checked={typeSearch === "terms"}
                onChange={(e) => setTypeSearch(e)}
              >
                PALABRAS CLAVE
              </Radio>
            </div>
          </RadioGroup>
        </Col>
        <Col xs={12} md={4} className="d-flex flex-column">
          <InputForm
            label="Texto a buscar"
            name="textToSearch"
            type="text"
            value={values.textToSearch}
            touched={touched.textToSearch}
            error={errors.textToSearch}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
          />
          <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-2 mb-3">
            <Button style={{ background: "#585657" }} type="submit">
              Buscar
            </Button>
          </div>
        </Col>

        <Col
          xs={12}
          md={4}
          className="d-flex flex-column justify-content-center align-items-center gap-5"
        >
          {values.typeDocument !== "acuerdos" && (
            <div className="d-flex justify-content-center gap-5">
              <div className="text-right">
                <h5>Búsqueda avanzada</h5>
              </div>
              <div className="d-flex justify-content-start">
                <Toggle
                  checked={showForm}
                  color="#585657"
                  onChange={() => setShowForm(!showForm)}
                />
              </div>
            </div>
          )}
          <div className="">
            <Button onClick={() => clean()}>Limpiar</Button>
          </div>
        </Col>
      </Row>

      <Row className="d-flex justify-content-around">
        <Col
          xs={12}
          md={5}
          className="d-flex flex-column justify-content-center align-items-center mt-3"
        ></Col>
        <Col
          xs={12}
          md={5}
          className="d-flex flex-column justify-content-center align-items-center mt-3"
        ></Col>
      </Row>

      <Row className="d-flex justify-content-around align-items-center">
        <Col
          xs={12}
          md={5}
          className="d-flex flex-column justify-content-center"
        ></Col>
      </Row>

      <Row className="">
        <Animation.Collapse in={showForm && values.typeDocument !== "acuerdos"}>
          {(props, ref) => (
            <div ref={ref} {...props}>
              {values.typeDocument === "sentencias" && (
                <div>
                  <div className="text-center">
                    <h3>
                      Selecciona alguno(s) de los siguientes filtros para
                      obtener mejores resultados
                    </h3>
                  </div>

                  <CollapseFilter
                    showComponent={showAddresForm}
                    setShowComponent={adminCollapse}
                    title="Filtro por delimitación territorial"
                    keyWord="addres"
                    active={
                      values.region || values.distrito || values.area || values.number ||
                      values.year
                        ? true
                        : false
                    }
                  >
                    <AddresForm
                      errors={errors}
                      handleBlur={handleBlur}
                      onChange={onChange}
                      touched={touched}
                      values={values}
                      areas={areas}
                      distritos={distritos}
                      regiones={regiones}
                    />
                  </CollapseFilter>
                  {!amnistia && (
                    <CollapseFilter
                      showComponent={showCaseForm}
                      setShowComponent={adminCollapse}
                      title="Filtro por materia y juicio"
                      keyWord="case"
                      active={
                        values.folderType ||
                        values.subject ||
                        values.system ||
                        values.delito
                          ? true
                          : false
                      }
                    >
                      <DocumentForm
                        errors={errors}
                        handleBlur={handleBlur}
                        onChange={onChange}
                        touched={touched}
                        values={values}
                        delitos={delitos}
                        materias={materias}
                        setFieldValue={setFieldValue}
                        showForm={showForm}
                        setShowForm={setShowForm}
                        tiposCarpeta={tiposCarpeta}
                        sistemas={sistemas}
                        instancias={instancias}
                        amnistia={amnistia}
                      />
                    </CollapseFilter>
                  )}

                  <CollapseFilter
                    showComponent={showDatesForm}
                    setShowComponent={adminCollapse}
                    title="Fechas"
                    keyWord="dates"
                    active={
                      values.startDate || values.endDate ? true : false
                    }
                  >
                    <DatesSwitchForm
                      errors={errors}
                      handleBlur={handleBlur}
                      onChange={onChange}
                      touched={touched}
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                  </CollapseFilter>
                  <CollapseFilter
                    showComponent={showPerspectives}
                    setShowComponent={adminCollapse}
                    title="Perspectivas"
                    keyWord="perspectives"
                    active={values.searchWithPerspectives}
                  >
                    <Perspectives onChange={onChange} values={values} />
                  </CollapseFilter>
                </div>
              )}

              {values.typeDocument === "tesis" && (
                <CollapseFilter
                  showComponent={showTesis}
                  setShowComponent={adminCollapse}
                  title="Filtros"
                  keyWord="jurisprudence"
                  active={
                    values.distrito ||
                    values.area ||
                    values.subject ||
                    values.year ||
                    values.region ||
                    values.jur
                      ? true
                      : false
                  }
                >
                  <FormTesis
                    handleBlur={handleBlur}
                    errors={errors}
                    onChange={onChange}
                    touched={touched}
                    values={values}
                    tipos={tipos}
                    regiones={regiones}
                    materias={materias}
                    areas={areas}
                    distritos={distritos}
                  />
                </CollapseFilter>
              )}
            </div>
          )}
        </Animation.Collapse>
      </Row>
    </div>
  );
}
